import { P1 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations';
import React, { ReactElement } from 'react';
import styles from './Benefit.module.scss';

export type BenefitProps = {
  icon: ReactElement;
  textKey: string;
  percentageToShow?: string
};

export const Benefit = (props: BenefitProps) => {
  const { t } = useTranslation();
  return props.percentageToShow ? (
    <div className={styles.benefitWrapper}>
      {props.icon}
      <P1 className={styles.benefitText}>{t(props.textKey, {percentage: props.percentageToShow})}</P1>
    </div>
  ) : (
      <div className={styles.benefitWrapper}>
        {props.icon}
        <P1 className={styles.benefitText}>{t(props.textKey)}</P1>
      </div>
  );
};
